import { MfListResponse } from "../domain/models/mf-list.model";
import { SidebarModules } from "../infraestructure/dto/sidebar.interface";

export const mfListMock: MfListResponse =
{
  code: 200,
  message:'accion ejecutada con exito',
  data: [
    {
      module_id: "ACTIVA",
      name: "Activa",
      slug: "activa",
      mfurl: "",
      active: false,
      hasChildren:false,
      order:1
    },
    {
      module_id: "INICIO",
      name: "Inicio",
      slug: "inicio",
      mfurl: "https://dev360.leal.co/mf-cms-home/remoteEntry.js",
      // mfurl: 'http://localhost:4210/remoteEntry.js',
      active: true,
      hasChildren:false,
      order:0
    },
    {
      module_id: "MISCLIENTES",
      name: "CDP: Mis clientes",
      slug: "misclientes",
      mfurl:"",
      active: true,
      hasChildren:true,
      order:2,
      children:[
        {
          module_id: "CLIENTESCRM",
          name: "Clientes",
          slug: "clientes",
          mfurl: "https://dev360.leal.co/mf-cms-construct/remoteEntry.js",
          // mfurl: 'http://localhost:4201/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:0
        },
        {
          module_id: "ESTADISTICAS",
          name: "Estadísticas",
          slug: "estadisticas",
          mfurl: "https://dev360.leal.co/mf-cms-construct/remoteEntry.js",
          // mfurl: 'http://localhost:4201/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:0
        },
        {
          module_id: "AUDIENCIAS",
          name: "Audiencias",
          slug: "audiencias",
          mfurl: "https://dev360.leal.co/mf-cms-segment/remoteEntry.js",
          // mfurl: 'http://localhost:4202/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:2
        },
        {
          module_id: "TRANSACCIONES",
          name: "Transacciones",
          slug: "transacciones",
          mfurl: "https://dev360.leal.co/mf-cms-transactions/remoteEntry.js",
          // mfurl: 'http://localhost:4209/remoteEntry.js',
          active: false,
          hasChildren:false,
          order:1
        },
        {
          module_id: "CLIENTES",
          name: "Clientes",
          slug: "clientes",
          mfurl: "https://dev360.leal.co/mf-cms-clients/remoteEntry.js",
          // mfurl: 'http://localhost:4208/remoteEntry.js',
          active: false,
          hasChildren:false,
          order:3
        },
      ]
    },
    {
      module_id: "CAMPANAS",
      name: "Campañas",
      slug: "campanas",
      mfurl: "",
      active: true,
      hasChildren: true,
      order:3,
      children: [
        {
          module_id: "MISCAMPANAS",
          name: "Mis Campañas",
          slug: "miscampanas",
          mfurl: `https://dev360.leal.co/mf-cms-campaigns/remoteEntry.js?v=${new Date().getTime()}`,
          // mfurl: "http://localhost:4207/remoteEntry.js",
          active: true,
          hasChildren: false
        },
        {
          module_id: "AUTOMATIZADAS",
          name: "Automatizadas",
          slug: "automatizadas",
          mfurl: `https://dev360.leal.co/mf-cms-campaigns/remoteEntry.js?v=${new Date().getTime()}`,
          // mfurl: "http://localhost:4207/remoteEntry.js",
          active: true,
          hasChildren: false
        }
      ]
    },
    {
      module_id: "BENEFICIOS",
      name: "Beneficios",
      slug: "beneficios",
      mfurl: "",
      hasChildren: true,
      active: true,
      order:5,
      children: [
        {
          module_id: "BONOS",
          name: "Bonos",
          slug: "bonos",
          // mfurl: "https://dev360.leal.co/mf-cms-bonos/remoteEntry.js",
          mfurl: 'http://localhost:4203/remoteEntry.js',
          active: false,
          hasChildren:false,
          order:1
        },
        {
          module_id: "PREMIOS",
          name: "Premios",
          slug: "premios",
          mfurl: "https://dev360.leal.co/mf-cms-loyalize/remoteEntry.js",
          // mfurl: 'http://localhost:4204/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:0
        },
        {
          module_id: "PROMOCIONES",
          name: "Promociones",
          slug: "promociones",
          mfurl:"",
          // mfurl: 'null',
          active: false,
          hasChildren:false,
          order:2
        },
      ]
    },
    {
      module_id: "VOZDELCLIENTE",
      name: "Voz del cliente",
      slug: "vozdelcliente",
      mfurl: "https://dev360.leal.co/mf-cms-listen/remoteEntry.js",
      // mfurl: 'http://localhost:4206/remoteEntry.js',
      active: true,
      hasChildren:false,
      order:4,
    },
    {
      module_id: "PERFIL",
      name: "Perfil",
      slug: "perfil",
      mfurl: "",
      active: true,
      hasChildren:true,
      order:6,
      children:[
        {
          module_id: "NOTIFICACIONES",
          name: "Notificaciones",
          slug: "notificaciones",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:0
        },
        {
          module_id: "PROFILE",
          name: "Perfil",
          slug: "miperfil",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:1
        },
        {
          module_id: "CONFIGURACIONCUENTA",
          name: "Configuración de cuenta",
          slug:'configuracioncuenta',
          mfurl: "https://dev360.leal.co/mf-cms-configuration/remoteEntry.js",
          // mfurl: 'http://localhost:4205/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:2
        },
        {
          module_id: "MEMBRESIA",
          name: "Membresía y facturación",
          slug: "membresiayfacturacion",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:3
        },
        {
          module_id: "PLANES",
          name: "Planes",
          slug: "Planes",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:4
        },
        {
          module_id: "AYUDA",
          name: "Ayuda y soporte",
          slug: "ayudaysoporte",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:5
        },
        {
          module_id: "CAMBIARCONSTRASENA",
          name: "Cambiar contraseaña",
          slug: "cambiarcontraseña",
          mfurl: "",
          // mfurl: '',
          active: false,
          hasChildren:false,
          order:6
        },
        {
          module_id: "CONFIGURACIONREGLAS",
          name: "Configuración de reglas",
          slug:'configuracion-reglas',
          mfurl: "https://dev360.leal.co/mf-cms-ruler-config/remoteEntry.js",
          // mfurl: 'http://localhost:4212/remoteEntry.js',
          active: true,
          hasChildren:false,
          order:7
        },
      ]
    }
  ]
}



//export const mfListMock: any = null;


export const sidebarModulesMock: SidebarModules[] =[
    {
        "module_id": "INICIO",
        "name": "Inicio",
        "slug": "inicio",
        "mfurl": 'https://dev360.leal.co/mf-cms-home/remoteEntry.js',
        "active": true,
        "hasChildren": false,
        "order": 0,
        "selected": false,
        "icon": "home",
        "tooltip": "Inicio",
        "isOpenSubMenu": false
    },
    {
        "module_id": "MISCLIENTES",
        "name": "Mis clientes",
        "slug": "misclientes",
        "mfurl": null,
        "active": true,
        "hasChildren": true,
        "order": 2,
        "children": [
            {
                "module_id": "INFOCLIENTES",
                "name": "Info clientes",
                "slug": "infoclientes",
                "mfurl": "https://dev360.leal.co/mf-cms-construct/remoteEntry.js",
                "active": true,
                "hasChildren": false,
                "order": 0
            },
            {
                "module_id": "AUDIENCIAS",
                "name": "Audiencias",
                "slug": "audiencias",
                "mfurl": "https://dev360.leal.co/mf-cms-segment/remoteEntry.js",
                "active": true,
                "hasChildren": false,
                "order": 2
            },
            {
                "module_id": "TRANSACCIONES",
                "name": "Transacciones",
                "slug": "transacciones",
                "mfurl": "null",
                "active": false,
                "hasChildren": false,
                "order": 1
            }
        ],
        "selected": false,
        "icon": "group",
        "tooltip": "Mis clientes",
        "isOpenSubMenu": false
    },
    {
        "module_id": "CAMPANAS",
        "name": "Campañas",
        "slug": "campanas",
        "mfurl": `https://dev360.leal.co/mf-cms-campaigns/remoteEntry.js?v=${new Date().getTime()}`,
        // "mfurl": "http://localhost:4207/remoteEntry.js",
        "active": true,
        "hasChildren": false,
        "order": 3,
        "selected": false,
        "icon": "campaign",
        "tooltip": "Campañas",
        "isOpenSubMenu": false
    },
    {
        "module_id": "VOZDELCLIENTE",
        "name": "Voz del cliente",
        "slug": "vozdelcliente",
        "mfurl": "https://dev360.leal.co/mf-cms-listen/remoteEntry.js",
        "active": true,
        "hasChildren": false,
        "order": 4,
        "selected": false,
        "icon": "star_border",
        "tooltip": "Voz del cliente",
        "isOpenSubMenu": false
    },
    {
        "module_id": "BENEFICIOS",
        "name": "Beneficios",
        "slug": "beneficios",
        "mfurl": null,
        "hasChildren": true,
        "active": true,
        "order": 5,
        "children": [
            {
                "module_id": "BONOS",
                "name": "Bonos",
                "slug": "bonos",
                "mfurl": "http://localhost:4203/remoteEntry.js",
                "active": true,
                "hasChildren": false,
                "order": 1
            },
            {
                "module_id": "PREMIOS",
                "name": "Premios",
                "slug": "premios",
                "mfurl": "https://dev360.leal.co/mf-cms-loyalize/remoteEntry.js",
                "active": true,
                "hasChildren": false,
                "order": 0
            },
            {
                "module_id": "PROMOCIONES",
                "name": "Promociones",
                "slug": "promociones",
                "mfurl": null,
                "active": false,
                "hasChildren": false,
                "order": 2
            }
        ],
        "selected": true,
        "icon": "emoji_events",
        "tooltip": "Beneficios",
        "isOpenSubMenu": false
    },
    {
        "module_id": "PERFIL",
        "name": "Perfil",
        "slug": "perfil",
        "mfurl": null,
        "active": true,
        "hasChildren": true,
        "order": 6,
        "children": [
            {
                "module_id": "CONFIGURACION",
                "name": "Configuración",
                "slug": "configuracion",
                "mfurl": "https://dev360.leal.co/mf-cms-configuration/remoteEntry.js",
                "active": true,
                "hasChildren": false,
                "order": 2
            }
        ],
        "selected": false,
        "icon": "adjust",
        "tooltip": "Perfil",
        "isOpenSubMenu": false
    },
    // {
    //     "module_id": "CONSTRUYE",
    //     "name": "Construye",
    //     "slug": "construye",
    //     "mfurl": "https://dev360.leal.co/mf-cms-construct/remoteEntry.js",
    //     "active": true,
    //     "hasChildren": false,
    //     "order": 8,
    //     "selected": false,
    //     "icon": "adjust",
    //     "tooltip": "Construye",
    //     "isOpenSubMenu": false
    // }
]

